import HeaderProgress from '../../components/module/create-proposal/common/header-progress';
import { useCreateProposalForm } from '../../hooks/actions/use-create-proposal-form';
import { useModalInfo } from '../../hooks/common/use-modal-info';
import FirstStep from '../../components/module/create-proposal/steps/first-step/first-step';
import SecondStep from '../../components/module/create-proposal/steps/second-step/second-step';
import ThirdStep from '../../components/module/create-proposal/steps/third-step/third-step';
import FourthStep from '../../components/module/create-proposal/steps/fourth-step/fourth-step';
import { useSelector } from 'react-redux';
import { selectCurrentStep } from '../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import ConfirmDefaultModal from '../../components/global/modal/confirm-default-modal';

export default function CreateProposalPage() {

    const currentStep = useSelector(selectCurrentStep);
    const { 
        isSaveProposal, 
        setIsSaveProposal, 
        handleSaveClientData, 
        handleSubmitProposal, 
        isLoading, 
        submitType, 
    } = useCreateProposalForm();
    const { modalTitle, modalSubTitle, } = useModalInfo(submitType);

    return (
        <>
            <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-[#f5f9fd] rounded-xl border border-gray-200/80">
                {/* ================================================= */}
                {/* HEADER PROGRESS */}
                {/* ================================================= */}
                <div className="sticky top-0 z-20 flex-shrink-0 border-b border-gray-200 bg-white p-3 py-3 shadow-sm sm:px-4 lg:px-5">
                    <HeaderProgress handleSaveClientData={handleSaveClientData} />
                </div>
                {/* ================================================= */}
                {/* STEP CONTENT */}
                {/* ================================================= */}
                <div className="min-h-0 flex-1 overflow-y-auto">
                    <div className="w-full px-3 py-3">
                        {currentStep === 1 && <FirstStep />}
                        {currentStep === 2 && <SecondStep />}
                        {currentStep === 3 && <ThirdStep />}
                        {currentStep === 4 && <FourthStep />}
                    </div>
                </div>
            </div>
            {/* ================================================= */}
            {/* SAVE PROPOSAL MODAL */}
            {/* ================================================= */}
            {isSaveProposal && (
                <ConfirmDefaultModal
                    modalTitle={modalTitle}
                    modalSubTitle={modalSubTitle}
                    onCancel={() => setIsSaveProposal(false)}
                    onConfirm={handleSubmitProposal}
                    isLoading={isLoading}
                />
            )}
        </>
    );
}